module.exports = "/assets/data/c752bb056866dc5844547c5100164abc-CT4.data.json";